import { jsx as _jsx } from "react/jsx-runtime";
import { FactEnum } from "@/types";
import { BedFrontIcon, CalendarIcon, CropSimpleIcon, DoorClosedIcon, ExpandIcon, StairsIcon, PlotSpaceIcon, FloorPlanIcon, ConstructionSiteHelmetIcon, } from "@gemini/icons";
export const FactMapIcon = {
    [FactEnum.numberOfRooms]: _jsx(DoorClosedIcon, {}),
    [FactEnum.livingSpace]: _jsx(FloorPlanIcon, {}),
    [FactEnum.numberOfFloors]: _jsx(StairsIcon, {}),
    [FactEnum.overallSpace]: _jsx(ExpandIcon, {}),
    [FactEnum.plotSpace]: _jsx(PlotSpaceIcon, {}),
    [FactEnum.numberOfBeds]: _jsx(BedFrontIcon, {}),
    [FactEnum.restaurantSpace]: _jsx(ExpandIcon, {}),
    [FactEnum.officeSpace]: _jsx(ExpandIcon, {}),
    [FactEnum.divisible]: _jsx(CropSimpleIcon, {}),
    [FactEnum.storageSpace]: _jsx(ExpandIcon, {}),
    [FactEnum.sellSpace]: _jsx(ExpandIcon, {}),
    [FactEnum.availability]: _jsx(CalendarIcon, {}),
    [FactEnum.numberOfBedrooms]: _jsx(BedFrontIcon, {}),
    [FactEnum.buildingPermission]: _jsx(ConstructionSiteHelmetIcon, {}),
    [FactEnum.deliveryDate]: _jsx(CalendarIcon, {}),
};
